import { render, staticRenderFns } from "./cursos.vue?vue&type=template&id=b30bc67c&scoped=true&"
import script from "./cursos.vue?vue&type=script&lang=ts&"
export * from "./cursos.vue?vue&type=script&lang=ts&"
import style0 from "./cursos.vue?vue&type=style&index=0&id=b30bc67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30bc67c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
